import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import RichText from '~/components/ui/RichText.vue';
export default {
  __name: 'BlockSeoMainTitleGraphql',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var descriptionBody = computed(function () {
      var _props$description;
      return props === null || props === void 0 ? void 0 : (_props$description = props.description) === null || _props$description === void 0 ? void 0 : _props$description.json;
    });
    return {
      __sfc: true,
      props: props,
      descriptionBody: descriptionBody,
      RichText: RichText
    };
  }
};